// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-example-runner-jsx": () => import("./../../../src/pages/example-runner.jsx" /* webpackChunkName: "component---src-pages-example-runner-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-chart-gallery-page-jsx": () => import("./../../../src/templates/chart-gallery-page.jsx" /* webpackChunkName: "component---src-templates-chart-gallery-page-jsx" */),
  "component---src-templates-doc-page-jsx": () => import("./../../../src/templates/doc-page.jsx" /* webpackChunkName: "component---src-templates-doc-page-jsx" */),
  "component---src-templates-home-jsx": () => import("./../../../src/templates/home.jsx" /* webpackChunkName: "component---src-templates-home-jsx" */)
}

